import React from 'react';
import Icon from '../icon/Icon';
import Tooltip from '../tooltip/Tooltip';
import { isAvalAnnulable } from '../../utils/guaranteeAnnulUtils';

const ANNUL_DISABLED_TOOLTIP = 'Solo se pueden anular avales pendientes';

interface GuaranteeAnnulActionsProps {
  monetizationStatusTypeId?: number | null;
  onAnnulClick: () => void;
}

const GuaranteeAnnulActions: React.FC<GuaranteeAnnulActionsProps> = ({
  monetizationStatusTypeId,
  onAnnulClick,
}) => {
  const annulable = isAvalAnnulable(monetizationStatusTypeId);

  const icon = (
    <Icon
      name='delete_outline'
      variant={annulable ? 'danger' : 'neutral'}
      modifier={annulable ? 'regular' : 'weak'}
      width={24}
      height={24}
      cursor={annulable ? 'pointer' : 'not-allowed'}
      onClick={annulable ? onAnnulClick : undefined}
      style={annulable ? undefined : { opacity: 0.45 }}
    />
  );

  if (annulable) {
    return icon;
  }

  return (
    <Tooltip position='top' msg={ANNUL_DISABLED_TOOLTIP}>
      {icon}
    </Tooltip>
  );
};

export default GuaranteeAnnulActions;
